// libraries.
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import { electricPurple500, monserratSemiBold } from "@habitech/shared";

// hook.
import { useCreateRuleForm } from "./useCreateRuleForm";

// components.
import { CreateRuleFields } from "./CreateRuleFields";

// ─── Props ────────────────────────────────────────────────────────────────────

interface Props {
  show: boolean;
  country: string;
  onClose: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const CreateRuleModal = ({ show, country, onClose }: Props) => {
  const {
    methods,
    onSubmit,
    isSaving,
    tools,
    isLoadingTools,
    subConditionArray,
    actionArray,
    emptySubCondition,
    emptyAction,
  } = useCreateRuleForm({ show, country, onClose });

  return (
    <Modal show={show} onHide={onClose} centered size="lg" scrollable>
      <Modal.Header
        closeButton
        style={{ borderBottom: `2px solid ${electricPurple500}` }}
      >
        <Modal.Title
          style={{ fontFamily: monserratSemiBold, fontWeight: 600, fontSize: 16 }}
        >
          Nueva regla
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form id="create-rule-form" onSubmit={onSubmit}>
          <CreateRuleFields
            register={methods.register}
            errors={methods.formState.errors}
            watch={methods.watch}
            setValue={methods.setValue}
            tools={tools}
            isLoadingTools={isLoadingTools}
            subConditionArray={subConditionArray}
            actionArray={actionArray}
            emptySubCondition={emptySubCondition}
            emptyAction={emptyAction}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #eee" }}>
        <Button className="btn-habi-white" onClick={onClose} disabled={isSaving}>
          Cancelar
        </Button>
        <Button type="submit" form="create-rule-form" className="btn-habi" disabled={isSaving || isLoadingTools}>
          {isSaving ? <Spinner size="sm" animation="border" /> : "Crear regla"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
